import { Button } from '@mui/material'

export interface FileViewItem {
  id: number
  name: string
  link: string
  uploadedAt?: string
}

interface FileViewWidgetProps {
  files?: FileViewItem[]
}

export default function FileViewWidget({ files = [] }: FileViewWidgetProps) {
  const handleClick = (link: string) => {
    const a = document.createElement('a')
    a.href = link
    a.target = '_blank'

    a.click()
    a.remove()
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      {(files || []).map((file, i) => (
        <Button
          key={i}
          onClick={() => handleClick(file.link)}
          sx={{ textAlign: 'start' }}
        >
          {file.name}
        </Button>
      ))}
    </div>
  )
}
